import { Box } from '@mui/material';
import React, { FC } from 'react';
import { Typography700 } from 'views/common/components';
import StyledBox from 'views/rebranded-module/membership-module/MembershipLandingViewV2/components/MembershipBenefitsSection/MembershipBenefitsSection.styles';
import { RiCheckFill } from 'react-icons/ri';
import { useContent } from 'views/rebranded-module/common/context/useContent';

const MembershipBenefitsSection: FC<any> = () => {
  const content = useContent('MembershipLandingPage');

  return (
    <StyledBox>
      <Box>
        <Typography700 variant="h2" mb={4} mt={3} textAlign="center">
          {content.benefitsTitle}
        </Typography700>
        <Box className="MBSWrapper">
          <Box>
            {content.benefitsList.map((benefit, index) => (
              <Box display="flex" key={benefit.benefitText} mb={2}>
                <RiCheckFill className="MBSBenfitItemIcon" />
                <Typography700
                  pl={1}
                  variant="body1"
                  className="MBSBenefitItem"
                  color="text.secondary">
                  {benefit.benefitText}
                </Typography700>
              </Box>
            ))}
          </Box>

          <Typography700 mt={4} className="MBSFootnote" color="text.secondary">
            {content.benefitsFootNote}
          </Typography700>
        </Box>
      </Box>
    </StyledBox>
  );
};

export { MembershipBenefitsSection };
